import { put, takeLatest } from 'redux-saga/effects';
import { HostActionCreators } from 'src/store/reducers/host/action-creators';
import { HostActionEnum } from 'src/store/reducers/host/types';
import instance from '../set';

function* fetchGetHost({ id }: ReturnType<typeof HostActionCreators.getHost>) {
  try {
    const { data, status } = yield instance.get(`/host/reviews/${id}`);
    yield put(HostActionCreators.resultGetHost(data, status));
  } catch (error) {
    console.log('error :>> ', error);
  }
}
export function* actionWatcherGetHost() {
  yield takeLatest(HostActionEnum.REQUEST_HOST, fetchGetHost);
}
